/**
 * 授权信息弹框组件
 * 平台统一处理授权信息的弹框
 * 调用方式: new Grant(options)
 * @module common/grant
 */

 import UIAlert from '../common/uiutil.popup.src.js';
 import Env from './env';

import HalfScreenDialog from './halfScreenDialog';
import ajaxCall from './ajaxcall';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import report11332 from '../report/11332_batch';
import * as Base from '../base/mbase';

let GameGrantSubmit = {
    GAME_GRANT_SUBMIT_APPROVE : 1,  // 同意
    GAME_GRANT_SUBMIT_DENY : 2     // 拒绝
  };
const GrantType = {
    SHOW_POPUP: 1,
    JUMP_MIDDLE_PAGE: 2,
};

// 授权业务类型
const GameGrantCategory = {
    GAME_GRANT_CATEGORY_FINE_GAME : 0,  // 精品游戏
    GAME_GRANT_CATEGORY_MINI_GAME : 1,  // 小游戏
}

// 授权类型
const GrantCategory = {
    GAME_ACCOUNT_STATUS : 1,  // 精品游戏账号信息授权
    GAME_RELATE_STATUS : 2,  // 精品游戏用户关系链授权信息
    WXAG_GAME_LOGIN_STATUS: 3, // 小游戏登录授权信息
    WXAG_GAME_ACCOUNT_STATUS: 4, // 小游戏账号授权信息
}
  
const MiddlePage = "https://game.weixin.qq.com/cgi-bin/h5/static/group/grant.html";

let instance = null;
let pageDialogInstance = null;
let isPageGrant = false

function Grant(options) {
    if(!instance){
        instance = this.initDom();
        this.init(options);
    } else {
        return instance;
    }
}


// 销毁实例
Grant.prototype.hide = function() {
    this.destoryDom();
    if ( instance ) {
      instance = null;
    }
    if ( pageDialogInstance ) {
      pageDialogInstance = null;
    }
    if( !isPageGrant ) {
        this.unlockScreen();
    }
  }

/**
* 初始化弹框实例
* @return 弹框dom元素
*/
Grant.prototype.initDom = function() {
    const div = document.createElement('div');
    div.classList.add('js-grant-wrapper');
    return div;
}

/**
* 销毁弹框实例
*/
Grant.prototype.destoryDom = function() {
    const dom =  document.querySelector('#js-grant-wrapper');
    if (dom) {
      dom.parentNode.removeChild(dom);
    }
}

/**
* 根据后台返回的数据初始化弹框数据
* @param {any} options
*/
Grant.prototype.init = async function (options){

    
    let self = this;
    this.url = options?.url || '';
    // 保存回调函数
    this.successCbk = options?.success || function () {}
    this.cancelCbk = options?.cancel || function () {}
    // 获取授权信息
    this.appid = options?.grantInfo?.appid || '';
    this.bizid = +options?.grantInfo?.biz_id;
    let type = +options?.grantInfo?.type || 1;

    if(!options?.grantInfo?.appid){
        this.successCbk({
            is_auth: true,
        });
        this.hide();
        return;

    }


    if (!this.bizid) { // 找不到biz_id，不处理
        this.successCbk({
            is_auth: true,
        });
        this.hide();
        return;
    }

    let grantInfo = options.grantInfo || null;
    if(grantInfo){
        let isAuth = false;
        if ('is_auth' in grantInfo) { // 业务传递了 is_auth
            isAuth = grantInfo.is_auth;
        } else  {
            isAuth = await this.getAuthStatus(this.bizid, this.appid)
        }
        if(isAuth){
            // 如果不需要授权则直接执行回调
            self.successCbk({
                is_auth: true
            });
            this.hide();
        } else {
            this.lockScreen();
            if(type === GrantType.JUMP_MIDDLE_PAGE){
                this.showGrantPage({
                    biz_id: this.bizid,
                    appid: this.appid,
                    url: window.location.href,
                  });
                  isPageGrant = true;
            } else {
                // 曝光上报
                this.report({
                    pid: 0,
                    aid: 1,
                    ext: JSON.stringify({
                        // GameAccountStatus:
                        BizId: this.bizid
                    })
                })
                ajaxCall(
                    '/cgi-bin/gameusergrantwap/getusergrantinfo',
                    JSON.stringify({
                        method: 'POST',
                        "biz_id": this.bizid,
                        "appid": this.appid,
                    }),
                    function (res) {
                        self._init(res.data);
                    },
                    function() {
                        self.hide();
                        UIAlert.alert('系统出错了');
                        return;
                })

            }
            
        }
    }
    return options;

}

/**
* 根据appid, biz_id 获取是否授权
* @param {number} biz_id
* @param {string} appid
*/
Grant.prototype.getAuthStatus = function (biz_id, appid) {
    let self = this;
    return new Promise(function (resolve, reject) {
        ajaxCall(
            '/cgi-bin/gameusergrantwap/getusergrantbizcontrol',
            {
                biz_id: biz_id,
                appid: appid,
            },
            function (res) {
                if (res?.errcode === 0 && res?.data) {
                    resolve(res.data?.is_auth || false);
                  }
            },
            function () {
                self.hide();
                UIAlert.alert('系统出错了');
                return;
            }
        )
    })
}

/**
* 根据后台返回的数据初始化弹框数据
* @param {any} options
*/
Grant.prototype._init = function (options) {
    let self = this;
    this.insertStyle();
    this.title = options.interface_config?.title || {};
    this.list = options.interface_config?.body?.item_list || [];

    this.category = options.category || GameGrantCategory.GAME_GRANT_CATEGORY_FINE_GAME;
    if( this.category === GameGrantCategory.GAME_GRANT_CATEGORY_MINI_GAME){
        this.footer = options.interface_config?.footer?.wxag_content || '';

    } else {
        this.footer = options.interface_config?.footer?.content || '';
    }

    let statusList = options.user_grant_info_list || [];
    // 根据后台数据初始化 ruleList
    this.ruleList = [];
    for(let i = 0, len = this.list.length; i < len; i++) {
        let item = this.list[i];
        let status = statusList.find(v => v.item_id === item.item_id);
        let item_status = item.status_list.find(v => v.item_status_value === status.item_status_value);
        this.ruleList.push({
            item_id: item.item_id,
            item_status_value: item_status.item_status_value,
            item_status_name: item_status.item_status_name
        })
    }
    this.showRangeSelect = false; // 是否选择授权范围弹框
    this.curentGrantId = 0; // 当前选择的授权信息id
    this.currentRange = {}; // 当前选择的授权范围
    this.currentRangeId = 0; // 当前选择的授权范围

    this.initGrant();
}

/**
* 初始化半屏弹框
*/
Grant.prototype.initGrant = function () {
    let self = this;
    this.halfScreenDialog = new HalfScreenDialog(
        self.getHtml(),
        [{
            label: '取消',
            type: 'default',
            callback: function () {
                if(self.showRangeSelect){
                    self.timer = setTimeout(() => {
                        self.halfScreenDialog.update(self.getHtml());
                        self.showRangeSelect = false;
                      }, 200);
                    

                } else {
                    // 点击取消上报
                    self.report({
                        pid: 2,
                        aid: 2,
                        ext: JSON.stringify({
                            BizId: self.bizid,
                        })
                    })

                    if (self.timer) {
                        clearTimeout(self.timer);
                        self.timer = null;
                    }
                    self.hide();
                    self.cancelCbk(self.list);
                }
                
            }
        },
        {
            label: '确认',
            type: 'primary',
            callback: function () {
                if(self.showRangeSelect){
                    self.ruleList = self.ruleList.map(item =>{
                        if(item.item_id === self.curentGrantId){
                            item.item_status_value = self.currentRange.item_status_value;
                            item.item_status_name = self.currentRange.item_status_name;
                        }
                        return item;
                    })
                    self.timer = setTimeout(() => {
                        self.halfScreenDialog.update(self.getHtml());
                        self.showRangeSelect = false;
                      }, 200);

                } else {
                    // 点击确定上报
                    if(self.category === 1){ // 小游戏上报
                        let WxagGameLoginStatus = self.ruleList.find(v => v.item_id === GrantCategory.WXAG_GAME_LOGIN_STATUS);
                        let WxagGameAccountStatus = self.ruleList.find(v => v.item_id === GrantCategory.WXAG_GAME_ACCOUNT_STATUS);
                        self.report({
                            pid: 3,
                            aid: 2,
                            ext: JSON.stringify({
                                WxagGameLoginStatus: +WxagGameLoginStatus.item_status_value,
                                WxagGameAccountStatus: +WxagGameAccountStatus.item_status_value,
                                BizId: self.bizid
                            })
                        })
                    } else {
                        let GameAccountStatus = self.ruleList.find(v => v.item_id === GrantCategory.GAME_ACCOUNT_STATUS);
                        let GameRelateStatus = self.ruleList.find(v => v.item_id === GrantCategory.GAME_RELATE_STATUS);
                        self.report({
                            pid: 3,
                            aid: 2,
                            ext: JSON.stringify({
                                GameAccountStatus: +GameAccountStatus.item_status_value,
                                GameRelateStatus: +GameRelateStatus.item_status_value,
                                BizId: self.bizid
                            })
                        })

                    }
                    self.hide();
                    if (self.timer) {
                        clearTimeout(self.timer);
                        self.timer = null;
                    }
                    let user_grant_info_list = self.ruleList.map(v =>{
                        return {
                            item_id: v.item_id,
                            item_status_value: v.item_status_value
                        }
                    })

                    ajaxCall(
                        '/cgi-bin/gameusergrantwap/setusergrantinfo',
                        JSON.stringify({
                            method: 'POST',
                            "user_grant_info_list": user_grant_info_list,
                            "submit_value": GameGrantSubmit.GAME_GRANT_SUBMIT_APPROVE,
                            "appid": self.appid,
                            "biz_id": self.bizid
                        }),
                        function (res) {
                            if(self.url){
                                wxBridge.openUrl(self.url)
                            }
                            let param = {
                                is_auth: res.data?.is_auth || false
                            }
                            self.successCbk(param);
                        },
                        function() {
                            self.hide();
                            UIAlert.alert('系统出错了');
                        })

                    
                }
            }
        }]
    )

}

/**
* 授权弹框样式
*/
Grant.prototype.insertStyle = function () {
    let dom = document.getElementById('global_subscribe_style');
    if(!dom) {
        let dom = document.createElement('style')
        dom.setAttribute('type', "text/css")
        dom.setAttribute('id', "global_subscribe_style")

        let style = `
            @font-face {
                font-family: "WeChatGameIcon";
                src: url('data:font/truetype;charset=utf-8;base64,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') format('truetype');
                /* iOS 4.1- */
                font-style: normal;
                font-weight: normal; 
            }
 
            .arrow-container {
                align-items: center;
                justify-content: center;
                padding: 0 2PX;
                width: 24PX;
                height: 24PX;
                border-radius: 12PX;
                background-color: #F7F7F7;
            }
            .wxgamelib-grant .popup { position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.5); }
            .wxgamelib-grant .popup__content {bottom: 0;background-color: #FFFFFF;border-radius: 12PX 12PX 0PX 0PX;width: 100%;padding: 20PX 24PX;font-family: PingFang SC;font-style: normal;font-weight: normal; box-sizing: border-box;}
            .wxgamelib-grant .icon-font_family { font-family: WeChatGameIcon; }
            .wxgamelib-grant .popup__content-flex { display: flex;align-items: center; }
            .wxgamelib-grant .popup__content-game_info-icon { width: 24PX;height: 24PX;vertical-align: middle; }
            .wxgamelib-grant .popup__content-game_info-game_name { margin-left: 8PX;color: rgba(0, 0, 0, 0.9);font-weight: 500;font-size: 15PX;line-height: 21PX;vertical-align: middle; }
            .wxgamelib-grant .popup__content-item { position: relative;color: rgba(0, 0, 0, 0.9);font-size: 17PX;line-height: 24PX;padding: 16PX 0; }
            .wxgamelib-grant .popup__content-item:after { content: '';position: absolute;left: 0;right: 0;bottom: 0;transform: scaleY(.5);border-top: 1PX solid rgba(0, 0, 0, 0.1) }
            .wxgamelib-grant .popup__content-title { margin-top: 12PX;font-weight: 500; }
            .wxgamelib-grant .popup__content-item-account { justify-content: space-between;align-items: center; }
            .wxgamelib-grant .popup__content-item-left { color: rgba(0, 0, 0, 0.5);font-size: 14PX;display: flex;align-items: center;flex-shrink: 0;max-width: 50%; }
            .wxgamelib-grant .popup__content-item-tips { font-size: 14PX;color: rgba(0, 0, 0, 0.3);line-height: 20PX;flex-shrink: 1; }
            .wxgamelib-grant .popup__content-item-friend { padding: 10PX 0;display: flex;justify-content: space-between;align-items: center; }
            .wxgamelib-grant .popup__content_tips { color: rgba(0, 0, 0, 0.3);font-size: 14PX;line-height: 20PX;padding: 16PX 0; }
            .wxgamelib-grant .popup__content_tips_link { color: #576b95; }
            .wxgamelib-grant .popup__content-overflow{ overflow: auto; height: 100%; }
            .wxgamelib-grant .popup__content-overflow::-webkit-scrollbar{ width: 0; }
            .wxgamelib-grant .line_clamp-single{ overflow:hidden;text-overflow:ellipsis;white-space:nowrap; }
            .wxgamelib-grant .lineClamp_many{ overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2; }
            /* 授权范围弹窗样式 */
            .wxgamelib-grant .select_popup { position: fixed;bottom: 0;background-color: #FFFFFF;border-radius: 12PX 12PX 0PX 0PX;width: 100%;height: 427.5PX;font-family: PingFang SC;font-style: normal;font-weight: normal; }
            .wxgamelib-grant .select_popup__top-title { display: flex;align-items: center;justify-content: space-between;padding: 20PX 16PX;color: rgba(0, 0, 0, 0.9);font-weight: 500;font-size: 15px;line-height: 21px; }
            .wxgamelib-grant .select_popup__top-title-icon { display: flex;align-items: center;font-size: 16px;flex-shrink: 0;margin-right: 30PX; line-height: 24px; padding-left: 2px; }
            .wxgamelib-grant .select_popup__content { padding: 0 24PX; }
            .wxgamelib-grant .select_popup__content—item { display: flex;align-items: center;justify-content: space-between;padding: 16PX 0;position: relative;font-size: 17px;line-height: 24px;color: rgba(0, 0, 0, 0.9); }
            .wxgamelib-grant .select_popup__content—item:after { content: '';position: absolute;left: 0;right: 0;bottom: 0;transform: scaleY(.5);border-top: 1PX solid rgba(0, 0, 0, 0.1) }
            .wxgamelib-grant .select_popup__content—item-icon { width: 24PX;height: 24PX;flex-shrink: 0;margin-left: 5PX; }
            .wxgamelib-grant .select_popup__content—item-icon-img { width: 100%;height: 100%; }
            .wxgamelib-grant .select_popup-icon_selected { display: inline-block; }
            .wxgamelib-grant .select_popup-icon_hide { display: none;}
            .wg_dark_mode .wxgamelib-grant .popup__content-game_info-game_name { color: rgba(255, 255, 255, 0.8);}
            .wg_dark_mode .wxgamelib-grant .popup__content-item { color: rgba(255, 255, 255, 0.8); }
            .wg_dark_mode .wxgamelib-grant .popup__content-item-left { color: rgba(255, 255, 255, 0.5); }
            .wg_dark_mode .wxgamelib-grant .popup__content-item-tips { color: rgba(255, 255, 255, 0.3); }
            .wg_dark_mode .wxgamelib-grant .popup__content_tips { color: rgba(255, 255, 255, 0.3); }
            .wg_dark_mode .wxgamelib-grant .popup__content_tips_link { color: #7d90a9; }
            .wg_dark_mode .wxgamelib-grant .popup__content-item:after { border-top: 1PX solid rgba(255, 255, 255, 0.05); }
            .wg_dark_mode .wxgamelib-grant .popup__content { background-color: #232323; }
            .wg_dark_mode .wxgamelib-grant .select_popup { background-color: #232323; }
            .wg_dark_mode .wxgamelib-grant .select_popup__top-title { color: rgba(255, 255, 255, 0.8); }
            .wg_dark_mode .wxgamelib-grant .select_popup__content—item { color: rgba(255, 255, 255, 0.8); }
            .wg_dark_mode .wxgamelib-grant .select_popup__content—item:after { border-top: 1PX solid rgba(255, 255, 255, 0.05); }
            .wg_dark_mode .wxgamelib-grant .arrow-container {background-color: #1e1e1e;}
            #Eevee_grant_page {
                position: fixed;
                z-index: 100001;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: #ffffff;
              }
              
            .grant {
                width: 100vw;
                height: 100vh;
                overflow: hidden;
                padding-bottom: 34PX;
            }
            .grant__content {
                height: calc(100% - 88PX);
                align-items: center;
                justify-content: space-between;
            }
            .grant__content-title {
                font-size: 22PX;
                color: rgba(0, 0, 0, 0.9);
                margin: 32PX 32PX 8PX 32PX;
                font-weight: 500;
                text-align: center;
            }
            .grant__content-description {
                font-size: 15PX;
                color: rgba(0, 0, 0, 0.3);
                margin: 0 32PX 0 32PX;
                text-align: center;
            }
            .grant__content-bottom {
                position: fixed;
                bottom: 128PX;
                left: 0;
                right: 0;
            }
            .grant__content-button {
                width: 184PX;
                height: 40PX;
                font-size: 17PX;
                background-color: #07c160;
                color: #ffffff;
                margin:0 auto;
                text-align: center;
                justify-content: center;
                line-height: 40PX;
            }
            .grant__content-imagebox {
                max-width: 430PX;
                margin: 32PX 67PX 0;
                
            }
            .grant__content-image {
                width: 100%;
            }
              
            .wg_dark_mode #Eevee_grant_page {
                background-color: #191919;
            }
              
            .wg_dark_mode .grant__content-title {
                color: rgba(255, 255, 255, 0.8);
            }
              
            .wg_dark_mode .grant__content-description {
                color: rgba(255, 255, 255, 0.3);
            }
              
            .wg_dark_mode .grant__content-button {
                background-color: #018942;
            }
        `

        dom.innerHTML = style
        let head = document.getElementsByTagName('head')[0]
        head.appendChild(dom)
    }
}

/**
* 初始化授权项 html
* @returns 授权项弹框内容
*/
Grant.prototype.getHtml = function () {
    let self = this;
    let list = this.list;
    let title = this.title;

    let html = [{
        html : `
        <div class="wxgamelib-grant">
        <div class="popup__content">
        <div class="popup__content-flex popup__content-game_info">
                    <img class="popup__content-game_info-icon"
                        src="${title.game_icon_url || ''}">
                    <span class="popup__content-game_info-game_name">${title.game_name || ''}</span>
                </div>
                <div>  
                <div class="popup__content-flex popup__content-item popup__content-title">${title.title || ''}
                </div>
    `
    }];
    for(let i = 0, len = list.length; i < len; i++) {
        let item = list[i];

         // 判断是否隐藏某些授权范围
        let statusList = this.removeHideStatus(item.status_list);
        this.ruleList = this.ruleList.map(rule =>{
            if(rule.item_id === item.item_id){
                if(statusList && statusList.findIndex(v => v.item_status_value === rule.item_status_value) === -1){
                    let status = statusList[0];
                    rule.item_status_value = status.item_status_value;
                    rule.item_status_name = status.item_status_name;
                }
            }
            return rule;
        })

        let rule = this.ruleList.find(v => v.item_id === item.item_id);
        if(!this.getHideCondition(item.hide_if_list)){
            html.push({
                target: '.item-' + item.item_id,
                callback(res) {  // 弹出授权选择页
                    self.showRangeSelect = true; // 是否选择授权范围弹框
                    self.curentGrantId = item.item_id; // 当前选择的授权信息
                    self.currentRange = {
                        item_status_value: rule.item_status_value,
                        item_status_name: rule.item_status_name
                    }
                    self.currentRangeId = rule.item_status_value;
                    self.halfScreenDialog.update(self.getRangeSelectHtml(item.status_list), true)
                },
                html :  `
                <div class="popup__content-item">
                                <div class="${'popup__content-flex ' + (item.item_desc === undefined ? 'popup__content-item-friend' : 'popup__content-item-account')}">
                                    <div class="line_clamp-single">${item.item_name}</div>
                                    <div class="${'popup__content-item-left item-' + item.item_id} " >
                                        <span class="line_clamp-single">${rule.item_status_name}</span>
                                        <span class="icon-font_family">R</span>
                                    </div>
                                </div>
                                <div class="popup__content-item-tips line_clamp-single">${item.item_desc || ''}</div>
                            </div>
            `
            })
        } else {
            // 如果被隐藏则需要设置为不授权 3
            self.ruleList = self.ruleList.map(v => {
                let length = item.status_list.length;
                if( v.item_id === item.item_id){
                    v.item_status_value = item.status_list[length-1].item_status_value;
                    v.item_status_name = item.status_list[length-1].item_status_name;
                }
                return v;
            })
        }
        

    }

    html.push({
        html : `
        <div class="popup__content_tips">${this.footer}
                    </div>
                </div>
            </div>
            </div>
    `,
    })

    return html
}

/**
* 初始化每个授权项对应的授权范围 html
* @param {any} status_list
* @returns 授权范围弹框内容
*/
Grant.prototype.getRangeSelectHtml = function (status_list) {
    let self = this;
    let html = [{
        target: '.select_popup__top-back',
        callback(res) {  // 订阅成功回调
            self.halfScreenDialog.update(self.getHtml(), false)
        },
        html : `
        <div class="wxgamelib-grant">
        <div class="select_popup__top-title">
            <span class="icon-font_family select_popup__top-title-icon select_popup__top-back">L</span>
            <div class="line_clamp-single">选择授权范围</div>
            <span class="icon-font_family select_popup__top-title-icon"></span>
        </div>
        <div class="select_popup__content"> 
    `
    }];
    for(let i = 0, len = status_list.length; i < len; i++) {
        let range = status_list[i];
        html.push({
            target: '.range_item-'+range.item_status_value,
            callback(res) {  // 订阅成功回调
                self.currentRange = range;
                self.currentRangeId = range.item_status_value;
                self.halfScreenDialog.update(self.getRangeSelectHtml(status_list), true)

            },
            html :  `
            <div class="${'select_popup__content—item ' + 'range_item-' + range.item_status_value}">
                <div class="line_clamp-single">${range.item_status_name}</div>
                <div class="select_popup__content—item-icon">
                    <img class="${'select_popup__content—item-icon-img ' + (self.currentRangeId === range.item_status_value ? 'select_popup-icon_selected' : 'select_popup-icon_hide')} "
                        src="https://mmgame.qpic.cn/image/59c2bf71f9d4300400f644f202b825d6418203f70ab7e1418b2686099c6a65a1/0">
                </div>
            </div>
        `
        });

    }

    html.push({
        html : '</div> </div>',
    })
    return html;
}

  /**
    * 根据用户的选择，判断其他选项的授权范围
    * @param {any} statusList
    * @returns 可选择的授权范围
    */
   Grant.prototype.removeHideStatus = function(statusList) {
    let list = [];
    const getHideStatus = (statusHideList) => {
        for (let i = 0, len = statusHideList.length; i < len; i++) {
            const item = statusHideList[i];
            const target = this.ruleList.find(v=> v.item_id === item.item_id);
            if (target.item_status_value === item.item_status_value) {
              return true;
            }
          }
          return false;
    };
    for (let i = 0, len = statusList.length; i < len; i++){
        const item = statusList[i];
        let statusHideList = item.item_status_hide_if_list || [];
        if(!getHideStatus(statusHideList)){
            list.push(item);
        }
    }
    return list;
}

/**
* 获得每个授权项的隐藏状态并更新被隐藏的元素为不授权
* @param {any} hideList
* @returns 是否需要进行隐藏
*/
Grant.prototype.getHideCondition = function (hideList) {
    for(let i = 0, len = hideList.length; i < len; i++) {
        let item = hideList[i];
        let target = this.ruleList.find(v => v.item_id === item.item_id);
        if(target.item_status_value === item.item_status_value){
            return true;
        }
    }
    return false;
}

// 授权中间页
Grant.prototype.showGrantPage = function(options) {
    if (!this.pageInstance) {
      this.pageInstance = this.initGrantPage(options);
    }
  }

Grant.prototype.initGrantPage =  async function (params) {
    if (!params?.biz_id) {
      this.pageInstance = null;
      return null;
    }

    // 中间页曝光上报
    this.report({
        scene: 145,
        uia: 14502,
        pid: 0,
        aid: 1,
        ext: JSON.stringify({
          BizId: params.biz_id,
        }),
      });

    const pageInfo = await this.getPageGrantInfo({
      biz_id: params.biz_id,
      appid: params.appid,
      dark_mode: Env.isDarkMode,
    });

    // 设置导航栏颜色
    wxBridge.verifyJsapi(['setNavigationBarColor'], () => {
        wxBridge.invoke('setNavigationBarColor', {color: Env.isDarkMode ? '#191919' : '#ffffff'});
    })

    // 设置导航栏标题
    wxBridge.verifyJsapi(['setPageTitle'], () => {
        wxBridge.invoke('setPageTitle', {title: ' '});
    })

    // 初始化页面
    const imgUrl = Env.isDarkMode ? pageInfo.screenshot_url_dark : pageInfo.screenshot_url;
    this.pageInstance = this.initGrantPageInstance({
      title: pageInfo.title || '',
      description: pageInfo.description || '',
      screenshot_url: imgUrl || '',
    });

    // 插入样式

    this.insertStyle();

    // 绑定事件
    this.pageBindEvents(params);
    this.proccessDarkModeChange(pageInfo);
    return this.pageInstance;
  }


  Grant.prototype.getPageGrantInfo = function(data) {
    const proccessError = () => {
        this.hideGrantPage();
        UIAlert.alert('系统出错了');
    };

    return new Promise(function (resolve, reject) {
        ajaxCall(
            '/cgi-bin/gameusergrantwap/getusergrantbizinfo',
            data,
            function (res) {
                if (res?.errcode === 0 && res?.data) {
                    resolve(res?.data?.biz_interface_config || {});
                } else {
                    proccessError();
                }
            },
            function () {
                proccessError();
            }
        );
    })
    
    
}

Grant.prototype.proccessDarkModeChange =  function(params) {
    const proccess = () => {
      const imgUrl = Env.isDarkMode ? params.screenshot_url_dark : params.screenshot_url;
      if (this.pageInstance) {
        this.pageInstance.$update(imgUrl);
      }
      // 设置导航栏颜色
      wxBridge.verifyJsapi(['setNavigationBarColor'], () => {
        wxBridge.invoke('setNavigationBarColor', {color: Env.isDarkMode ? '#191919' : '#ffffff'});
        })
    };

    Env.onDarkModeChange(() => {
        proccess();
    })

};

Grant.prototype.pageBindEvents =  function(params) {

    const close = () => {
        wxBridge.invoke('closeWindow', {}, function(res){      
            if(res?.err_msg.indexOf?.('ok') < 0 ){
                setTimeout(() => {
                    close();
                }, 200);
            }
        })

    }
    // 授权按钮事件绑定
    const successHandler = () => {
      if (params?.url) {
          if(Env.isiOS){
              wxBridge.openUrl(
                params.url,
                {},
                function() {
                    close();
                }
            );
          } else {
            window.location.replace(params?.url);
          }
      }
      this.hide();
      this.unlockScreen();
      pageDialogInstance = null;
    };

    const cancelHandler = () => {
        this.destoryDom();
      };

    const getGrant = () => {
        isPageGrant = true;
        if(!pageDialogInstance){
            // 点击去授权上报
            this.report({
                scene: 145,
                uia: 14502,
                pid: 1,
                aid: 40,
                ext: JSON.stringify({
                    BizId: params.biz_id,
                }),
            });

            pageDialogInstance = this.initDom();

            this.init({
                grantInfo: {
                  biz_id: params.biz_id,
                  appid: params.appid,
                },
                success(res) {
                  if (res.is_auth) {
                    successHandler();
                  }
                },
                cancel() {
                    cancelHandler();
                },
              });
        }
    };
    const dom = document.querySelector('.grant__content-bottom');
    if (dom) {
      dom.addEventListener('click', getGrant, false);
    }
}

// 关闭授权中间页
Grant.prototype.hideGrantPage = function() {
    if (this.pageInstance) {
      this.pageInstance.$destroy();
      document.body.removeChild(this.pageInstance.$el);
      this.pageInstance = null;
    }
    // 解除屏幕锁定
    this.unlockScreen();
  }

Grant.prototype.initGrantPageInstance = function(data){
    const divid = 'Eevee_grant_page';
  const dom = document.querySelector('.Eevee_grant_page');
  if (dom) {
    dom.parentNode.removeChild(dom);
  }
  const spinnerDiv = document.createElement('div');
  spinnerDiv.id = divid;
  document.body.appendChild(spinnerDiv);
  const tpl = `
        <div class="wxgamelib-grant">
        <div class="grant">
            <div class="grant__content">
                <div class="grant__content-title" > ${data.title} </div>
                <div class="grant__content-description"> ${data.description} </div>
                <div class="grant__content-imagebox">
                <img
                    src="${data.screenshot_url}"
                    class="grant__content-image"
                ></img>
                </div>
                <div class="grant__content-bottom">
                    <div class="grant__content-button">去授权</div>
                </div>
                
                
            </div>
        </div>
        </div>
        `;
  spinnerDiv.innerHTML = tpl;
  return {
    $destroy() {},
    $update(url) {
      const dom = document.querySelector('.grant__content-image');
      if (dom) {
        dom.setAttribute('src', url);
      }
    },
    $el: spinnerDiv,
  };
}

// 禁止页面滚动
let normalOverflow = '';
Grant.prototype.lockScreen = function() {
    if (!normalOverflow && document.body.style.overflow !== 'hidden') {
        normalOverflow = document.body.style.overflow;
    }
    document.body.style.overflow = 'hidden';
}
// 打开页面滚动
Grant.prototype.unlockScreen = function() {
    document.body.style.overflow = normalOverflow || 'auto';
}

Grant.prototype.report = function(obj) {
    let map  = {
        scene   : 'iSceneId',
        uia     : 'iUIArea',
        pid     : 'iPositionId',
        ext     : 'sExternInfo',
        aid     : 'iActionId',
        op      : 'iOpType',
        gid     : 'sGameId',
        ssid    : 'iSourceSceneId',
        astsuts : 'sActionStatus'
    };

    let defaultRep = {
        scene   : 145,
        uia     : 14501,
        gid   : this.appid,
    };

    let rep = Base.extend(defaultRep, obj);

    for ( let key in rep ) {
        if ( map[key] ) {
            rep[map[key]] = rep[key];

            delete rep[key];
        }
    }

    report11332([rep])
}

export default Grant;